function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.75 4.75H3.25c-.844 0-1.5.675-1.5 1.5v12.5c0 .854.646 1.5 1.5 1.5h17.5c.825 0 1.5-.656 1.5-1.5V6.25c0-.815-.685-1.5-1.5-1.5Zm0-1H3.25a2.492 2.492 0 0 0-2.5 2.5v12.5c0 1.406 1.094 2.5 2.5 2.5h17.5c1.367 0 2.5-1.094 2.5-2.5V6.25c0-1.367-1.133-2.5-2.5-2.5Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.969 13.828a1.863 1.863 0 0 1-2.656 0 1.838 1.838 0 0 1 0-2.617 1.863 1.863 0 0 1 2.656 0c.351.351.937.351 1.328 0 .351-.39.351-.977 0-1.328a3.726 3.726 0 0 0-5.313 0c-.742.703-1.093 1.64-1.093 2.617a3.72 3.72 0 0 0 1.093 2.656 3.691 3.691 0 0 0 2.657 1.094c.976 0 1.914-.352 2.656-1.094.351-.351.351-.937 0-1.328a.968.968 0 0 0-1.328 0ZM17.469 13.828a1.863 1.863 0 0 1-2.657 0 1.838 1.838 0 0 1 0-2.617 1.863 1.863 0 0 1 2.657 0c.351.351.937.351 1.328 0 .351-.39.351-.977 0-1.328a3.726 3.726 0 0 0-5.313 0c-.742.703-1.093 1.64-1.093 2.617a3.72 3.72 0 0 0 1.093 2.656 3.691 3.691 0 0 0 2.657 1.094c.976 0 1.914-.352 2.656-1.094.351-.351.351-.937 0-1.328a.968.968 0 0 0-1.328 0Z"
});

function SvgCcOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcOutline);
export default __webpack_public_path__ + "static/media/cc-outline.43816863.svg";
export { ForwardRef as ReactComponent };